import { IconButton } from '@/components/Buttons/IconButton';
import colors from "@/constants/Colors";

export const IconBgButton = ({bg, backgroundColor, p, ...rest}) => {
    return (
        <IconButton 
            reduceMotion 
            backgroundColor={bg || backgroundColor || {light: colors.muted[100], dark: colors.muted[800]}} 
            p={p ?? 7.5} 
            {...rest} 
        />
    )
}
